(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Stats-Neon"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    var animate = root.dataset.animate === 'true';
    var cards = root.querySelectorAll('.sn__card');

    // cursor-follow glow
    cards.forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var target = parseFloat(el.dataset.target);
      if (isNaN(target)) return;
      var decimals = parseInt(el.dataset.decimals || '0', 10);
      var prefix = el.dataset.prefix || '';
      var suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = prefix + target.toFixed(decimals) + suffix; return; }
      var dur = 1400, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) {
        c.classList.add('is-in');
        countUp(c.querySelector('.sn__value'));
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var i = Array.prototype.indexOf.call(cards, card);
        setTimeout(function () {
          if (animate) card.classList.add('is-in');
          countUp(card.querySelector('.sn__value'));
        }, animate ? i * 110 : 0);
        io.unobserve(card);
      });
    }, { threshold: 0.4 });

    cards.forEach(function (c) { io.observe(c); });
  }

  document.querySelectorAll('.sn').forEach(initSection);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.sn');
    if (root) initSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Trusted-brands"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    // reveal
    if (root.dataset.animate === 'true' && 'IntersectionObserver' in window) {
      var revs = root.querySelectorAll('.tb__intro,.tb__logo,.tb__review');
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Array.prototype.indexOf.call(revs, e.target);
          setTimeout(function () { e.target.classList.add('is-in'); }, i * 50);
          ro.unobserve(e.target);
        });
      }, { threshold: 0.15 });
      revs.forEach(function (el) { ro.observe(el); });
    }

    // pop + hover-float on logo tiles (lift, tilt toward cursor, settle back)
    root.querySelectorAll('[data-pop]').forEach(function (logo) {
      var inner = logo.querySelector('.tb__logo-inner');
      if (!inner) return;
      logo.addEventListener('pointermove', function (e) {
        var r = logo.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        inner.style.setProperty('--ry', (px * 16) + 'deg');
        inner.style.setProperty('--rx', (-py * 16) + 'deg');
      });
      logo.addEventListener('pointerleave', function () {
        inner.style.setProperty('--ry', '0deg');
        inner.style.setProperty('--rx', '0deg');
      });
    });

    // subtle 3D tilt on review cards
    root.querySelectorAll('[data-tilt]').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (px * 5) + 'deg) rotateX(' + (-py * 5) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  document.querySelectorAll('.tb').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.tb');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Why-Holofex"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.animate !== 'true' || !('IntersectionObserver' in window)) return;
    var items = root.querySelectorAll('.wh__item');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var i = Array.prototype.indexOf.call(items, entry.target);
        setTimeout(function () { entry.target.classList.add('is-in'); }, i * 80);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.3 });
    items.forEach(function (it) { io.observe(it); });
  }
  document.querySelectorAll('.wh').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.wh');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holofex-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hf-display-compare')) {
  customElements.define('hf-display-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const templates = [...this.querySelectorAll('template[data-product]')];
      const selects = [...this.querySelectorAll('[data-select]')];
      const update = select => {
        const template = templates.find(t => t.dataset.product === select.value);
        const slot = select.closest('.hfc-column').querySelector('[data-slot]');
        if (template) slot.replaceChildren(template.content.cloneNode(true));
        this.alignRows();
      };
      selects.forEach((select, index) => {
        select.selectedIndex = Math.min(index, select.options.length - 1);
        select.closest('label').hidden = false;
        select.addEventListener('change', () => update(select));
        update(select);
      });
      this.observer = new ResizeObserver(() => this.alignRows());
      this.observer.observe(this);
    }
    alignRows() {
      const columns = [...this.querySelectorAll('[data-slot]')];
      const groups = ['h4', '.hfc-variant', ...Array.from({length:6}, (_, i) => `dl > div:nth-child(${i + 1})`)];
      for (const selector of groups) {
        const rows = columns.map(c => c.querySelector(selector)).filter(Boolean);
        rows.forEach(r => r.style.minHeight = '');
        const height = Math.max(0, ...rows.map(r => r.getBoundingClientRect().height));
        rows.forEach(r => r.style.minHeight = `${height}px`);
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holofex-wall-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('holofex-wall-configurator')) {
    customElements.define('holofex-wall-configurator', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.form = this.querySelector('[data-configurator-form]');
        this.addButton = this.querySelector('[data-add-button]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.status = this.querySelector('[data-status]');
        this.preview = this.querySelector('[data-preview]');
        this.previewGrid = this.querySelector('[data-preview-grid]');
        this.models = [...this.querySelectorAll('[data-model]')];
        this.configurations = [...this.querySelectorAll('[data-configuration]')];
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency
        });
        this.preview.style.viewTransitionName = `holofex-preview-${this.dataset.sectionId}`;
        this.form?.addEventListener('change', () => this.update(true));
        this.form?.addEventListener('submit', (event) => this.addToCart(event));
        this.update(false);
      }

      getSelection() {
        const modelInput = this.querySelector('input[name^="holofex-size-"]:checked');
        const configurationInput = this.querySelector('input[name^="holofex-configuration-"]:checked');
        const model = modelInput?.closest('[data-model]');
        const configuration = configurationInput?.closest('[data-configuration]');
        if (!model || !configuration) return null;
        const diameter = Number(model.dataset.diameter);
        const spacing = Number(model.dataset.spacing);
        const columns = Number(configuration.dataset.columns);
        const rows = Number(configuration.dataset.rows);
        const quantity = columns * rows;
        return {
          model,
          configuration,
          modelName: model.dataset.modelName,
          size: Number(model.dataset.model),
          diameter,
          spacing,
          overlap: diameter - spacing,
          clearance: Number(model.dataset.clearance),
          columns,
          rows,
          quantity,
          width: diameter + ((columns - 1) * spacing),
          height: diameter + ((rows - 1) * spacing),
          variantId: model.dataset.variantId,
          price: Number(model.dataset.price),
          available: model.dataset.available === 'true',
          inventory: Number(model.dataset.inventory),
          inventoryManaged: model.dataset.inventoryManaged === 'true',
          inventoryPolicy: model.dataset.inventoryPolicy,
          label: configuration.dataset.label
        };
      }

      update(animate) {
        const selection = this.getSelection();
        if (!selection) {
          this.addButton.disabled = true;
          this.addLabel.textContent = this.dataset.unconfiguredLabel;
          return;
        }
        const render = () => {
          this.drawPreview(selection);
          this.updateSummary(selection);
        };
        const canTransition = animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (canTransition) document.startViewTransition(render);
        else render();
      }

      drawPreview(selection) {
        this.previewGrid.replaceChildren();
        const availableWidth = this.preview.clientWidth;
        const availableHeight = this.preview.clientHeight;
        const scale = Math.min(availableWidth / selection.width, availableHeight / selection.height) * .9;
        const deviceSize = selection.diameter * scale;
        const gridWidth = selection.width * scale;
        const gridHeight = selection.height * scale;
        const originX = (availableWidth - gridWidth) / 2;
        const originY = (availableHeight - gridHeight) / 2;

        for (let row = 0; row < selection.rows; row += 1) {
          for (let column = 0; column < selection.columns; column += 1) {
            const device = document.createElement('span');
            const hub = document.createElement('i');
            const positionLabel = document.createElement('b');
            const mountLabel = document.createElement('b');
            const isTop = (row + column) % 2 === 0;
            device.className = `holofex-wall__device holofex-wall__device--${isTop ? 'top' : 'bottom'}`;
            hub.className = 'holofex-wall__hub';
            positionLabel.className = 'holofex-wall__position-label';
            positionLabel.textContent = `${row + 1}-${column + 1}`;
            mountLabel.className = 'holofex-wall__mount-label';
            mountLabel.textContent = isTop ? this.dataset.topLabel : this.dataset.bottomLabel;
            device.style.width = `${deviceSize}px`;
            device.style.left = `${originX + (column * selection.spacing * scale)}px`;
            device.style.top = `${originY + (row * selection.spacing * scale)}px`;
            device.style.zIndex = isTop ? '2' : '1';
            device.append(hub, positionLabel, mountLabel);
            this.previewGrid.append(device);
          }
        }

        const widthCm = this.formatCentimetres(selection.width);
        const heightCm = this.formatCentimetres(selection.height);
        this.preview.setAttribute('aria-label', this.template(this.dataset.previewTemplate, {
          model: selection.modelName,
          configuration: `${selection.columns} × ${selection.rows}`,
          quantity: selection.quantity,
          width: widthCm,
          height: heightCm
        }));
        this.setText('[data-preview-width]', `${widthCm} cm`);
        this.setText('[data-preview-height]', `${heightCm} cm`);
        this.setText('[data-preview-model]', selection.modelName);
        this.setText('[data-preview-layout]', `${selection.columns} × ${selection.rows}`);
        this.setText('[data-preview-units]', selection.quantity);
      }

      updateSummary(selection) {
        const widthCm = this.formatCentimetres(selection.width);
        const heightCm = this.formatCentimetres(selection.height);
        const total = this.moneyFormatter.format((selection.price * selection.quantity) / 100);
        this.setText('[data-summary-quantity]', selection.quantity);
        this.setText('[data-summary-footprint]', `${widthCm} × ${heightCm} cm`);
        this.setText('[data-summary-spacing]', `${selection.spacing} mm`);
        this.setText('[data-summary-overlap]', `${selection.overlap} mm`);
        this.setText('[data-summary-clearance]', `${selection.clearance} mm`);
        this.setText('[data-summary-configuration]', selection.label);
        this.setText('[data-summary-total]', selection.variantId ? total : '—');
        this.status.textContent = '';
        this.status.dataset.error = 'false';

        let disabled = false;
        let label = this.template(this.dataset.addTemplate, {
          quantity: selection.quantity,
          size: selection.size,
          total
        });
        if (!selection.variantId) {
          disabled = true;
          label = this.dataset.unconfiguredLabel;
        } else if (!selection.available) {
          disabled = true;
          label = this.dataset.unavailableLabel;
        } else if (selection.inventoryManaged && selection.inventoryPolicy !== 'continue' && selection.inventory < selection.quantity) {
          disabled = true;
          label = this.template(this.dataset.insufficientTemplate, { available: Math.max(0, selection.inventory) });
        }
        this.addButton.disabled = disabled;
        this.addLabel.textContent = label;
      }

      async addToCart(event) {
        event.preventDefault();
        const selection = this.getSelection();
        if (!selection || this.addButton.disabled) return;
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.addLabel.textContent = this.dataset.addingLabel;
        this.status.textContent = '';
        this.status.dataset.error = 'false';
        const footprint = `${this.formatCentimetres(selection.width)} × ${this.formatCentimetres(selection.height)} cm`;
        const properties = {};
        properties[this.dataset.propSize] = `${selection.size} cm`;
        properties[this.dataset.propConfiguration] = selection.label;
        properties[this.dataset.propQuantity] = String(selection.quantity);
        properties[this.dataset.propFootprint] = footprint;
        properties[this.dataset.propSpacing] = `${selection.spacing} mm`;
        properties[this.dataset.propOverlap] = `${selection.overlap} mm`;

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(selection.variantId), quantity: selection.quantity, properties }]
            })
          });
          if (!response.ok) throw new Error('Cart request failed');
          this.addLabel.textContent = this.dataset.addedLabel;
          this.status.textContent = this.dataset.addedLabel;
          if (this.dataset.cartBehavior === 'redirect') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        } catch (error) {
          this.status.textContent = this.dataset.errorLabel;
          this.status.dataset.error = 'true';
        } finally {
          this.addButton.removeAttribute('aria-busy');
          if (this.dataset.cartBehavior !== 'redirect') this.update(false);
        }
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      }

      formatCentimetres(millimetres) {
        return Number((millimetres / 10).toFixed(1)).toLocaleString(document.documentElement.lang || 'en');
      }

      template(source, values) {
        return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), source);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
